import BossModel from "@/models/BossModel";
import PlatinumPage from "@/models/PlatinumPage/PlatinumPage";
import Country from "@/models/Country/Country";
import Region from "@/models/Region/Region";

export default class PlatinumHotel extends BossModel {

    static apiUrl = 'platinum-hotel';

    static entity = 'platinumHotels';

    static fields() {
        return {
            id: this.number(null).nullable(),
            platinum_page_id: this.number(null),
            name: this.attr(null),
            country_id: this.number(null),
            region_id: this.number(null),
            platinumPage: this.belongsTo(PlatinumPage, 'platinum_page_id'),
            country: this.belongsTo(Country, 'country_id'),
            region: this.belongsTo(Region, 'region_id'),
        }
    }

    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(20)
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new PlatinumHotel(data[key]));
            }

            return instances;
        });
    }
}
